export const MAP_DEBOUNCE_TIME = 600; // ms
